/**
 * Homepage view configuration
 */
module.config(function ($stateProvider) {
    'use strict';
    $stateProvider
        .state('donationconfirmationdefault', {
            url: '/donation/confirm/:success', // TODO : translate or not ?
            controller: function ($stateParams, $state) {
                // redirect to correct page
                $state.go('donationconfirmation', { type: 'card', state: $stateParams.success });
            }
        })
        .state('donationconfirmation', {
            url: '/donation/confirm/:type/:state', // TODO : translate or not ?
            controller: function ($scope, $rootScope, $stateParams, donationsticky) {
                $scope.body = '';
                $scope.loading = true;
                $rootScope.nosticky = true;

                // evaluate type
                $scope.type = $stateParams.type;

                // evaluate state
                if ($stateParams.state === 'paid') {
                    $scope.state = 'success';
                } else {
                    $scope.state = 'failure';
                }

                // get site config
                var $watcher = $rootScope.$watchCollection('config.site', function (config) {
                    if (config) {
                        // config is ready
                        if (!config.payment) {
                            // some config are missing
                            $state.go('404');
                        } else {
                            // get diaporama config
                            if (config.don_slideshow) {
                                $scope.diapoDonation = config.don_slideshow.field_slides;
                                $scope.diapoDonationDelay = config.don_slideshow.field_delay;
                            }

                            // get message
                            if ($scope.state === 'success') {
                                $scope.title = 'Merci de votre don';
                            } else {
                                $scope.title = 'Une erreur est survenue';
                            }

                            $rootScope.title = $scope.title;
                            $scope.body = config.payment[$scope.type][$scope.state];

                            $scope.loading = false;
                        }
                    }
                });

                donationsticky.disable();

                // destroy watchers
                $scope.$on('$destroy', function () {
                    $watcher();
                    donationsticky.enable();
                });
            },
            template:
            '<div ng-if="loading" class="grid-main grid grid-v grid-center"><p class="aqua-form--loader grid grid-middle grid-center"><span class="aqua-form--loader-text">Chargement en cours...</span></p></div>' +

            '<div ng-if="!loading">' +
            '  <diaporama ng-if="diapoDonation" diapos="diapoDonation" delay="{{diapoDonationDelay}}" overlay="true"></diaporama>' +

            '  <div class="grid-main aqua-section--content aqua-richtext">' +
            '    <h1 class="grid grid-center"><span class="aqua-section--title">{{title}}</span></h1>' +
            '    <div class="aqua-donation--content aqua-richtext l-tac" ng-bind-html="body | trustAsHtml"></div>' +
            '    <p class="grid grid-center"><a ui-sref="homepage" class="aqua-section--button">Revenir à l\'accueil</a></p>' +
            '  </div>' +

            '</div>'
        });
});
